<template>
  <div id="show-group-client-portal">
    <v-card class="mt-3">
      <filtres-client-portal
        :criteria.sync="criteriaClientPortal"
      ></filtres-client-portal>
      <v-divider></v-divider>
      <v-card-text>
        <div id="table-portails-container">
          <client-portal-datatable
            :filter-params="criteriaClientPortal"
            v-on:fetch-records="$emit('fetch-records', $event)"
          ></client-portal-datatable>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import ClientPortalDatatable from "@/components/ClientPortal/ClientPortalDatatable";
import FiltresClientPortal from "@/components/ClientPortal/FiltresClientPortal";
import { useClientPortal } from "@/composables/client-portal";

export default {
  props: {
    group: Object,
  },
  components: {
    ClientPortalDatatable,
    FiltresClientPortal,
  },
  setup(props) {
    /* Import des API */
    const { criteriaClientPortal } = useClientPortal();

    criteriaClientPortal.value.group = props.group.id;

    return {
      criteriaClientPortal,
    };
  },
};
</script>
